// extracted by mini-css-extract-plugin
module.exports = {"button":"ShadowButton_button__JjXc8"};